import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const VOUCHER_API_URL = `${API_HOST}/api/voucher`;

function* createVoucher() {
  yield takeEvery(actions.CREATE_VOUCHER, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], VOUCHER_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.CREATE_VOUCHER_ENDED });
    }
  });
}

function* searchVouchers() {
  yield takeEvery(actions.SEARCH_VOUCHERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${VOUCHER_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_VOUCHERS_ENDED });
    }
  });
}

function* findVoucher() {
  yield takeEvery(actions.FIND_VOUCHER, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${VOUCHER_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_VOUCHER_ENDED });
    }
  });
}

function* updateVoucher() {
  yield takeEvery(actions.UPDATE_VOUCHER, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], VOUCHER_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_VOUCHER_ENDED });
    }
  });
}

function* deleteVouchers() {
  yield takeEvery(actions.DELETE_VOUCHERS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], VOUCHER_API_URL, { data: formData });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.DELETE_VOUCHERS_ENDED });
    }
  });
}

function* searchVoucherOrders() {
  yield takeEvery(actions.SEARCH_VOUCHER_ORDERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/voucherOrder?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_VOUCHERS_ORDERS_ENDED });
    }
  });
}

function* searchVoucherStatus() {
  yield takeEvery(actions.SEARCH_VOUCHER_STATUS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/pickupActivityVoucherOrder?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_VOUCHERS_ORDERS_ENDED });
    }
  });
}

function* findVoucherOrder() {
  yield takeEvery(actions.FIND_VOUCHER_ORDER, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${VOUCHER_API_URL}/voucherOrder/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_VOUCHER_ORDER_ENDED });
    }
  });
}

function* searchIssuedVouchers() {
  yield takeEvery(actions.SEARCH_ISSUED_VOUCHERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/voucherOrder/issuedVoucher?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_ISSUED_VOUCHERS_ENDED });
    }
  });
}

function* searchVoucherOrderTransactionRecords() {
  yield takeEvery(actions.SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/voucherOrder/transactionRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_VOUCHER_ORDER_TRANSACTION_RECORDS_ENDED });
    }
  });
}

function* searchIssuedVoucherTransactionRecords() {
  yield takeEvery(actions.SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/voucherOrder/issuedVoucher/transactionRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_ISSUED_VOUCHER_TRANSACTION_RECORDS_ENDED });
    }
  });
}

function* findIssuedVoucherTransactionRecord() {
  yield takeEvery(actions.FIND_ISSUED_VOUCHER_TRANSACTION_RECORD, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/voucherOrder/issuedVoucher/transactionRecord/${id}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_ISSUED_VOUCHER_TRANSACTION_RECORD_ENDED });
    }
  });
}

function* searchIssuedVoucherTransferRecords() {
  yield takeEvery(actions.SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${VOUCHER_API_URL}/voucherOrder/issuedVoucher/transferRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_ISSUED_VOUCHER_TRANSFER_RECORDS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createVoucher),
    fork(searchVouchers),
    fork(findVoucher),
    fork(updateVoucher),
    fork(deleteVouchers),
    fork(searchVoucherOrders),
    fork(searchVoucherStatus),
    fork(searchIssuedVouchers),
    fork(searchVoucherOrderTransactionRecords),
    fork(findVoucherOrder),
    fork(searchIssuedVoucherTransactionRecords),
    fork(findIssuedVoucherTransactionRecord),
    fork(searchIssuedVoucherTransferRecords),
  ]);
}
